import React from 'react';
import DropDown from '../../../common/dropdown/DropDown';
import Const from '../Const';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeComGroupCodeProprietary } from '../reducer';

const mapStateToProps = state => {
  return {
    comGroupCode: state[REDUCER_NAME].proprietary.comGroupCode,
  };
};

const mapDispatchToProps = {
  changeComGroupCode: changeComGroupCodeProprietary,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Filter);

function Filter({ comGroupCode, changeComGroupCode }) {
  return (
    <div className="list-filter">
      <div className="line-drop">
        <DropDown
          currentKey={comGroupCode}
          listKey={Const.listOrganCodeFilterProprietary}
          listDataByKey={Const.listFilterByOrganCode}
          change={changeComGroupCode}
        />
      </div>
    </div>
  );
}
